import { Check, Info, X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useLogo } from 'app/frontend/base/hooks/useLogo'
import { cn } from '@/lib/utils'
import { useUserIdsWithMultipleCandidates } from '../hooks'

type Props = {
  candidate: wowaudit.GuildCandidate
  className?: string
}

const CandidateUserBadge = ({ candidate, className }: Props) => {
  const { Logo } = useLogo()
  const userIdsWithMultipleCandidates = useUserIdsWithMultipleCandidates()

  const hasMultipleCandidates =
    !!candidate.userId && userIdsWithMultipleCandidates.has(candidate.userId)

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge
          className={cn('flex items-center gap-1 px-1', className)}
          variant='outline'
        >
          <Logo className='h-4 w-4 opacity-70' />
          {candidate.userId ? (
            hasMultipleCandidates ? (
              <Info size={13} className='text-info-foreground' />
            ) : (
              <Check size={13} className='text-success-foreground' />
            )
          ) : (
            <X size={13} className='text-destructive-foreground' />
          )}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <div className='text-center'>
          {candidate.userId ? (
            <>
              <div className='opacity-70 text-xs mb-0.5'>Battletag</div>
              <div>{candidate.userBattletag ?? 'Hidden user'}</div>
            </>
          ) : (
            <div className='italic text-muted-foreground'>
              Not claimed by anyone yet
            </div>
          )}
          {hasMultipleCandidates ? (
            <div className='text-xs text-info-foreground mt-1'>
              This user signed up with multiple characters
            </div>
          ) : null}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}

export default CandidateUserBadge
